import React from 'react';
import { Button, Dialog } from '@tencent/spaui';

const DialogMiniFooterComponent = (props) => {
  const { onCancel, onSubmit } = props;
  return (
    <div>
      <Button bsSize="small" onClick={onCancel}>
        取消
      </Button>
      <Button bsSize="small" bsStyle="primary" onClick={onSubmit}>
        确定
      </Button>
    </div>
  );
};
export default class ABulkMiniDialog extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      className,
      children,
      width,
      title,
      show,
      eventTarget,
      onCancel,
      onSubmit,
      onclose,
      eventTargetPlacement,
    } = this.props;
    // const { show, target } = this.state
    const inlineStyle = {
      width,
    };
    return (
      <div>
        <Dialog
          show={show}
          title={title ? title : ''}
          type={'simple'}
          hideHeader={!title}
          eventTarget={eventTarget}
          className={`modal-mini${className ? ` ${className}` : ''}`}
          onClose={onclose}
          onSubmit={onSubmit}
          onCancel={onCancel}
          eventTargetPlacement={eventTargetPlacement}
          FooterComponent={DialogMiniFooterComponent}
          style={inlineStyle}
        >
          {children}
        </Dialog>
      </div>
    );
  }
}
